import { MutationTree } from "vuex";
import { FilterState } from "@/store/modules/filters/filterTypes";

export const mutations: MutationTree<FilterState> = {
	setFilters(state, payload) {
		state.filters = payload;
	},
};
